import lodash from 'lodash'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import validator from 'validator'

import { FormRow } from '../../../../../1stlog-ui/src/components/Bootstrap'
import Field from '../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../1stlog-ui/src/components/Input'
import useReturnApp from '../../useReturnApp'

const validateEmail = (value: string): string | null =>
  !value || !validator.isEmail(value) ? i18n.t('invalid', 'Ungültig') : null

const validateEmailAllowEmpty = (value: string): string | null =>
  lodash.isString(value) &&
  lodash.get(value, 'length', 0) > 0 &&
  !validator.isEmail(value)
    ? i18n.t('invalid', 'Ungültig')
    : null

const LabelEmail = (): React.ReactElement => {
  const { receiver } = useReturnApp()

  if (!receiver.sendByMailAllowed) {
    return <></>
  }

  return (
    <FormRow>
      <Col>
        <Field
          key={`sendLabelToEmail_key_${receiver.sendByMailMandatory}`}
          name="sendLabelToEmail"
          label={i18n.t(
            'send_label_via_mail',
            'Label zusätzlich per Mail versenden',
          )}
          validate={
            receiver.sendByMailMandatory
              ? validateEmail
              : validateEmailAllowEmpty
          }
          required={receiver.sendByMailMandatory}
        >
          <Input />
        </Field>
      </Col>
    </FormRow>
  )
}

export default LabelEmail
